// frontend/src/hooks/useDashboard.js
import { useState, useEffect, useCallback } from 'react';
import { dashboardService , onboardingService} from '../utils/Api';

// Si loadData falla (ej: backend caído), profile nunca debe quedar sin plan_info:
// varias partes de la UI leen profile.plan_info.max_links sin chequeo previo.
const DEFAULT_PLAN_INFO = { plan_type: 'free', max_links: 5 };

export const useDashboard = () => {
  const [links, setLinks] = useState([]);
  const [profile, setProfile] = useState({
    plan_info: DEFAULT_PLAN_INFO,
    display_name: '',
    bio: '',
    background_color: '#ffffff',
    button_color:'#0d6efd',
    text_color:'#ffffff',
    title_color:'#212529',
    background_image_url: '',
    icon_url: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // Cargar datos
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const data = await dashboardService.getDashboardData();
      
      setLinks(data.links || []);
      setProfile({
        plan_info: data.planInfo || DEFAULT_PLAN_INFO,
        display_name: data.profile?.display_name || '',
        bio: data.profile?.bio || '',
        background_color: data.profile?.background_color || '#ffffff',
        text_color: data.profile?.text_color || '#ffffff',
        title_color: data.profile?.title_color || '#212529',
        button_color: data.profile?.button_color || '#0D6EFD',
        background_image_url: data.profile?.background_image_url || '',
        icon_url: data.profile?.icon_url || ''
      });
    } catch (err) {
      console.error('Error cargando datos:', err);
      setError('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  }, []);

  // Guardar cambios
  const saveChanges = async () => {
    try {
      setSaving(true);
      setError(null);
      
      // Guardar links
      const linksData = links.map((link, index) => ({
        id: link.id, // Si tiene id, actualiza; si no, crea nuevo
        title: link.title,
        url: link.url,
        icon: link.icon,
        position: index + 1 // Asegurar orden correcto
      }));
      
      await dashboardService.saveLinks(linksData);
      
      // Guardar perfil
      await dashboardService.updateProfile({
        display_name: profile.display_name,
        bio: profile.bio,
        background_color: profile.background_color,
        button_color: profile.button_color,
        text_color: profile.text_color,
        title_color: profile.title_color,
        background_image_url: profile.background_image_url,
        icon_url: profile.icon_url
      });
      
      // Recargar datos para asegurar consistencia
      await loadData();
      
      return { success: true };
    } catch (err) {
      console.error('Error guardando:', err);
      setError('Error al guardar los cambios');
      return { success: false, error: err.response?.data?.error || 'Error de conexión' };
    } finally {
      setSaving(false);
    }
  };

  // Cargar datos al montar
  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    links,
    setLinks,
    profile,
    setProfile,
    loading,
    saving,
    error,
    loadData,
    saveChanges
  };
};